import {
  Box,
  Stack,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  IconButton,
  Collapse,
  Tooltip,
} from "@mui/material";
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import NotificationsBar from "../header/NotificationsBar";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import BusinessIcon from "@mui/icons-material/Business";
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';

import GroupsIcon from "@mui/icons-material/Groups";
import LayersIcon from "@mui/icons-material/Layers";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty"; // Icone pour "en cours"
import DoneIcon from "@mui/icons-material/Done"; // Icone pour "terminées"
import FactCheckIcon from "@mui/icons-material/FactCheck"; //Icone pour validées
import EmailIcon from "@mui/icons-material/Email";
import ArticleIcon from "@mui/icons-material/Article";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import TableViewIcon from "@mui/icons-material/TableView";
import PostAddIcon from "@mui/icons-material/PostAdd";
import HistoryIcon from "@mui/icons-material/History";
import SyncLockSharpIcon from "@mui/icons-material/SyncLockSharp";
import SupervisorAccountTwoToneIcon from "@mui/icons-material/SupervisorAccountTwoTone";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

import { useAuth } from "../../contexts/AuthContext";
import Login from "./authentification/Login";

const drawerWidth = 240;
const navigationBarHeight = 64;

const MenuAdmin = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = React.useState(false);
  const [openReservations, setOpenReservations] = React.useState(false);
  const [openDevises, setOpenDevises] = React.useState(false);
  const [openSecurite, setOpenSecurite] = React.useState(false);
  const [openBureaux, setOpenBureaux] = React.useState(false);
  const { user } = useAuth();

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleCollapseToggle = () => {
    setCollapsed(!collapsed);
  };

  const handleReservationsClick = () => {
    setOpenReservations(!openReservations);
  };
  const handleDevisesClick = () => {
    setOpenDevises(!openDevises);
  };
  const handleSecuriteClick = () => {
    setOpenSecurite(!openSecurite);
  };
  const handleBureauxClick = () => {
    setOpenBureaux(!openBureaux);
  };  

  return (
    <Stack
      direction="column"
      justifyContent={"flex-start"}
      alignItems={"center"}
      sx={{ backgroundColor: "white", width: "100%", padding: 0 }}
    >
      {user?.user?.roles?.includes("admin") || user?.user?.roles?.includes("supadmin") ? (
        <Stack direction="row" sx={{ height: "100%", width: "100%" }}>
          <Drawer
            variant="persistent"
            anchor="left"
            open
            sx={{
              width: collapsed ? 60 : drawerWidth,
              flexShrink: 0,
              marginTop: `${navigationBarHeight}px`,
              "& .MuiDrawer-paper": {
                width: collapsed ? 60 : drawerWidth,
                boxSizing: "border-box",
                transition: "width 0.7s ease",
                marginTop: `${navigationBarHeight}px`,
              },
            }}
          >
            <IconButton onClick={handleCollapseToggle} sx={{ margin: 1 }}>
              {collapsed ? <MenuIcon /> : <MenuOpenIcon />}
            </IconButton>

            <List sx={{ "& .MuiListItem-root": { cursor: "pointer" }, paddingBottom: 12 }}>
              <ListItem button onClick={handleReservationsClick}>
                <ListItemIcon sx={{ color: 'goldenrod' }}>
                  <Tooltip title="Réservations"><ShoppingCartIcon /></Tooltip>
                </ListItemIcon>
                {!collapsed && <Typography variant="body1" sx={{ color: 'goldenrod' }}>Réservation</Typography>}
                {!collapsed && (openReservations ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
              </ListItem>
              <Collapse in={openReservations} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItem button sx={{ pl: 4 }} onClick={() => handleNavigation("/admin/gestionreservation/encours")}>
                    <ListItemIcon sx={{ color: 'black' }}><Tooltip title="Réservations en cours"><HourglassEmptyIcon /></Tooltip></ListItemIcon>
                    <Typography variant="body2">Réservations en cours</Typography>
                  </ListItem>
                  <ListItem button sx={{ pl: 4 }} onClick={() => handleNavigation("/admin/gestionreservation/validee")}>
                    <ListItemIcon sx={{ color: 'black' }}><Tooltip title="Réservations validées"><FactCheckIcon /></Tooltip></ListItemIcon>
                    <Typography variant="body2">Réservations validées</Typography>
                  </ListItem>
                  <ListItem button sx={{ pl: 4 }} onClick={() => handleNavigation("/admin/gestionreservation/terminee")}>
                    <ListItemIcon sx={{ color: 'black' }}><Tooltip title="Réservations terminée"><DoneIcon /></Tooltip></ListItemIcon>
                    <Typography variant="body2">Réservations terminée</Typography>
                  </ListItem>
                </List>
              </Collapse>

              <ListItem button onClick={handleDevisesClick}>
                <ListItemIcon sx={{ color: 'goldenrod' }}><Tooltip title="Devises"><CurrencyExchangeIcon /></Tooltip></ListItemIcon>
                {!collapsed && <Typography variant="body1" sx={{ color: 'goldenrod' }}>Devises</Typography>}
                {!collapsed && (openDevises ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
              </ListItem>
              <Collapse in={openDevises} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItem button sx={{ pl: 4 }} onClick={() => handleNavigation("/admin/tableaucours")}>
                    <ListItemIcon sx={{ color: 'black' }}><Tooltip title="Tableau de cours"><TableViewIcon /></Tooltip></ListItemIcon>
                    <Typography variant="body1">Tableau de cours</Typography>
                  </ListItem>
                  <ListItem button sx={{ pl: 4 }} onClick={() => handleNavigation("/admin/historique")}>
                    <ListItemIcon sx={{ color: 'black' }}><Tooltip title="Historique"><HistoryIcon /></Tooltip></ListItemIcon>
                    <Typography variant="body1">Historique</Typography>
                  </ListItem>
                  <ListItem button sx={{ pl: 4 }} onClick={() => handleNavigation("/admin/deviselistedit")}>
                    <ListItemIcon sx={{ color: 'black' }}><Tooltip title="Modification de devises"><PostAddIcon /></Tooltip></ListItemIcon>
                    <Typography variant="body1">Modification</Typography>
                  </ListItem>
                </List>
              </Collapse>

              <ListItem button onClick={() => handleNavigation("/admin/faqsadmin")}> <ListItemIcon sx={{ color: 'goldenrod' }}><Tooltip title="FAQs"><LiveHelpIcon /></Tooltip></ListItemIcon> {!collapsed && <Typography variant="body1" sx={{ color: 'goldenrod' }}>FAQs</Typography>} </ListItem>
              <ListItem button onClick={() => handleNavigation("/admin/newsadmin")}> <ListItemIcon sx={{ color: 'goldenrod' }}><Tooltip title="News"><ArticleIcon /></Tooltip></ListItemIcon> {!collapsed && <Typography variant="body1" sx={{ color: 'goldenrod' }}>News</Typography>} </ListItem>
              <ListItem button onClick={() => handleNavigation("/admin/contact")}> <ListItemIcon sx={{ color: 'goldenrod' }}><Tooltip title="Messages"><EmailIcon /></Tooltip></ListItemIcon> {!collapsed && <Typography variant="body1" sx={{ color: 'goldenrod' }}>Messages</Typography>} </ListItem>

              <ListItem button onClick={handleSecuriteClick}>
                <ListItemIcon sx={{ color: 'goldenrod' }}><Tooltip title="Sécurité"><SyncLockSharpIcon /></Tooltip></ListItemIcon>
                {!collapsed && <Typography variant="body1" sx={{ color: 'goldenrod' }}>Sécurité</Typography>}
                {!collapsed && (openSecurite ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
              </ListItem>
              <Collapse in={openSecurite} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItem button sx={{ pl: 4 }} onClick={() => handleNavigation("/admin/role")}> <ListItemIcon sx={{ color: 'black' }}><Tooltip title="Rôles"><AdminPanelSettingsIcon /></Tooltip></ListItemIcon> <Typography variant="body1">Rôles</Typography> </ListItem>
                  <ListItem button sx={{ pl: 4 }} onClick={() => handleNavigation("/admin/autorisations")}> <ListItemIcon sx={{ color: 'black' }}><Tooltip title="Autorisations"><HomeWorkIcon /></Tooltip></ListItemIcon> <Typography variant="body1">Autorisations</Typography> </ListItem>
                  <ListItem button sx={{ pl: 4 }} onClick={() => handleNavigation("/admin/listadmins")}> <ListItemIcon sx={{ color: 'black' }}><Tooltip title="Rôle Admin"><GroupsIcon /></Tooltip></ListItemIcon> <Typography variant="body1">Liste Admins</Typography> </ListItem>
                  <ListItem button sx={{ pl: 4 }} onClick={() => handleNavigation("/admin/listsupadmins")}> <ListItemIcon sx={{ color: 'black' }}><Tooltip title="Rôle Admin"><GroupsIcon /></Tooltip></ListItemIcon> <Typography variant="body1">Liste Sup Admins</Typography> </ListItem>
                  <ListItem button sx={{ pl: 4 }} onClick={() => handleNavigation("/admin/listclient")}> <ListItemIcon sx={{ color: 'black' }}><Tooltip title="Rôle Admin"><GroupsIcon /></Tooltip></ListItemIcon> <Typography variant="body1">Liste Clients</Typography> </ListItem>
                </List>
              </Collapse>

              <ListItem button onClick={handleBureauxClick}>
                <ListItemIcon sx={{ color: 'goldenrod' }}><Tooltip title="Bureaux"><BusinessIcon /></Tooltip></ListItemIcon>
                {!collapsed && <Typography variant="body1" sx={{ color: 'goldenrod' }}>Bureaux</Typography>}
                {!collapsed && (openBureaux ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
              </ListItem>
              <Collapse in={openBureaux} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItem button sx={{ pl: 4 }} onClick={() => handleNavigation("/admin/addbureau")}> <ListItemIcon sx={{ color: 'black' }}><Tooltip title="Ajouter bureau"><PlaylistAddIcon /></Tooltip></ListItemIcon> <Typography variant="body1">Ajouter bureau</Typography> </ListItem>
                  <ListItem button sx={{ pl: 4 }} onClick={() => handleNavigation("/admin/listbureaux")}> <ListItemIcon sx={{ color: 'black' }}><Tooltip title="Autorisations"><AutoAwesomeMotionIcon /></Tooltip></ListItemIcon> <Typography variant="body1">Liste bureaux</Typography> </ListItem>
                </List>
              </Collapse>
            </List>
          </Drawer>

          <Box sx={{ flexGrow: 1, padding: 2, overflow: "auto", transition: "margin-left 0.7s ease" }}>
            <NotificationsBar />
            <Outlet />
          </Box>
        </Stack>
      ) : (
        <Login />
      )}
    </Stack>
  );
};

export default MenuAdmin;
